import { defineAsyncComponent } from 'vue'
export default {
  centered: defineAsyncComponent(() => import("/usr/src/app/layouts/centered.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/usr/src/app/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/usr/src/app/layouts/empty.vue").then(m => m.default || m)),
  homepage: defineAsyncComponent(() => import("/usr/src/app/layouts/homepage.vue").then(m => m.default || m)),
  storybook: defineAsyncComponent(() => import("/usr/src/app/layouts/storybook.vue").then(m => m.default || m))
}